import React, { PureComponent } from "react";
import styled from "styled-components";
import TextLineAtom from "../../components/atoms/TextLineAtom";
import TextMarginAtom from "../../components/atoms/TextMarginAtom";
import { color, themeType, typo } from "../../styles/style";

const FooterBoxOuter = styled.div`
  display: flex;
  width: 100%;
  background: #0c0c0c;
  height: 100%;
  justify-content: flex-end;
  padding: 50px 0;
  margin-top: 150px;
`;
const FooterBox = styled.div`
  width: 100%;
  justify-content: center;
  flex-direction: column;
`;

const FooterContents = styled.div`
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  display: flex;
`;

function MoveNextUnicorn() {
  window.location.href = "https://www.nextunicorn.kr/company/7826c0a94c02e8eb";
}

function MoveRocketpunch() {
  window.location.href = "https://www.rocketpunch.com/companies/lab254";
}

function MoveGithub() {
  window.location.href = "https://github.com/LAB254-dev";
}

class AgreementsFooter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    return (
      <FooterBoxOuter>
        <FooterBox>
          <FooterContents>
            <TextLineAtom
              text="FOLLOW US"
              typo={typo.footer.f2}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="넥스트유니콘"
              typo={typo.footer.f3}
              onClick={MoveNextUnicorn}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="The VC"
              typo={typo.footer.f3}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="로켓펀치"
              typo={typo.footer.f3}
              onClick={MoveRocketpunch}
              color={color(themeType.light).text.primary}
            />
            <TextMarginAtom
              text="Github"
              typo={typo.footer.f3}
              onClick={MoveGithub}
              color={color(themeType.light).text.primary}
            />
          </FooterContents>
        </FooterBox>
      </FooterBoxOuter>
    );
  }
}

export default AgreementsFooter;
